module.exports = __webpack_public_path__ + "img/bi.3fce551.svg";